'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pullout = require('../../../pullout');

var _pullout2 = _interopRequireDefault(_pullout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Offer = function (_React$Component) {
  _inherits(Offer, _React$Component);

  function Offer() {
    _classCallCheck(this, Offer);

    return _possibleConstructorReturn(this, (Offer.__proto__ || Object.getPrototypeOf(Offer)).apply(this, arguments));
  }

  _createClass(Offer, [{
    key: 'render',
    value: function render() {
      var filteredProps = {
        content: {
          headline: {
            text: this.props.content.headline.text
          },
          cta: {
            text: this.props.content.cta.text,
            href: this.props.content.cta.href,
            color: 'outline-blue',
            fpti: 'Offer-ScndCTA-' + this.props.content.cta.text,
            target: this.props.content.cta.target || '_self'
          }
        },
        config: {
          appBadge: false,
          textAlign: 'center',
          id: this.props.config.id,
          theme: this.props.config.theme
        }
      };
      if (this.props.content.paragraph && this.props.content.paragraph.text) {
        filteredProps.content.paragraph = this.props.content.paragraph;
      }
      if (this.props.content.hatchText && this.props.content.hatchText.text) {
        filteredProps.content.hatchText = this.props.content.hatchText;
      }
      if (this.props.className) {
        filteredProps.className = this.props.className;
      }

      return _react2.default.createElement(_pullout2.default, filteredProps);
    }
  }]);

  return Offer;
}(_react2.default.Component);

exports.default = Offer;


Offer.propTypes = {
  config: _propTypes2.default.shape({
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']).isRequired,
    id: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    cta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired,
      color: _propTypes2.default.oneOf(['outline-blue']), // not visible
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

Offer.defaultProps = {
  config: {
    appBadge: false,
    textAlign: 'center',
    theme: 'theme-background-color-white',
    id: ''
  },
  content: {
    headline: {
      text: 'Fewer than 25 characters fit on one line in mobile.'
    },
    paragraph: {
      text: 'Fewer than 100 characters total to equal less than 3 lines in mobile.'
    },
    hatchText: {
      text: 'Fewer than 34 characters per line'
    },
    cta: {
      id: '',
      text: 'Fewer Than 29 Characters Max',
      href: '#',
      target: '_self'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/pullout/offer/jsx/Offer.js
// module id = 1136
// module chunks = 4